export default "__VITE_ASSET__CryXrBfk__"